import { Course } from 'model';
import { createAsyncAction } from 'typesafe-actions';

export const getCourses = createAsyncAction(
  'courses/GET_COURSES_REQUEST',
  'courses/GET_COURSES_SUCCESS',
  'courses/GET_COURSES_FAILURE',
)<undefined, Course[], undefined>();
